import axios from 'axios';
const cheerio = require('cheerio');
function formatDate(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
}

async function meteo() {
  const url = 'https://www.windfinder.com/forecast/watamu';
  const oggi = new Date();
  const data = new Date(oggi);
  const weatherForecast = {};

  try {
    const res = await axios.get(`https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`);
    const html = res.data;
    const $ = cheerio.load(html);

    const dati = $(".weathertable.forecast-day.forecast.forecast-day-8");

    dati.each((index, element) => {
      const giorno = element.children[3].children[1].children[0].data.trim();
      data.setDate(oggi.getDate() + index);
      const dataStringa = formatDate(data);
      weatherForecast[dataStringa] = {};

      for (let ora of element.children[5].children) {
        if ("attribs" in ora) {
          let valor = "";
          let windSpeed = 0;
          let windGust = 0;
          let orientamento = "";

          for (let argomento of ora.children) {
            if ("attribs" in argomento) {
              if (argomento.attribs.class == "cell-timespan weathertable__cellgroup weathertable__cellgroup--stacked") {
                valor = argomento.children[1].children[1].attribs;
                weatherForecast[dataStringa][parseInt(valor["data-value"])] = {};
              }

              if (argomento.attribs.class == "cell-wind-3 weathertable__cellgroup") {
                if (!("wind" in weatherForecast[dataStringa][parseInt(valor["data-value"])]))
                  weatherForecast[dataStringa][parseInt(valor["data-value"])]["wind"] = {};
                windSpeed = parseInt(argomento.children[1].children[1].children[1].children[1].children[0].data);
                windGust = parseInt(argomento.children[3].children[3].children[0].data);
                weatherForecast[dataStringa][parseInt(valor["data-value"])]["wind"]["velocita"] = windSpeed;
                weatherForecast[dataStringa][parseInt(valor["data-value"])]["wind"]["raffica"] = windGust;
              }

              if (argomento.attribs.class == "cell-wind-2 weathertable__cellgroup weathertable__cellgroup--stacked") {
                if (!("wind" in weatherForecast[dataStringa][parseInt(valor["data-value"])]))
                  weatherForecast[dataStringa][parseInt(valor["data-value"])]["wind"] = {};
                orientamento = argomento.children[1].children[1].attribs.style;
                weatherForecast[dataStringa][parseInt(valor["data-value"])]["wind"]["direzione"] = orientamento;
              }

              if (
                argomento.attribs.class === "cell-tides weathertable__cellgroup weathertable__cellgroup--stacked two" ||
                argomento.attribs.class === "cell-tides weathertable__cellgroup weathertable__cellgroup--stacked "
              ) {
                let marea = "";
                let oraMarea = null;
                let altezza = "";

                if (argomento.children[1].children[1].attribs.class === "data-tidedirection__symbol icon-spot-tide-low") {
                  marea = "low";
                } else if (argomento.children[1].children[1].attribs.class === "data-tidedirection__symbol icon-spot-tide-high") {
                  marea = "high";
                } else if (argomento.children[1].children[1].attribs.class === "data-tidedirection__symbol icon-spot-tide-up") {
                  marea = "up";
                } else {
                  marea = "down";
                }

                if (!(argomento.attribs.class === "cell-tides weathertable__cellgroup weathertable__cellgroup--stacked ")) {
                  oraMarea = argomento.children[3].children[1].children[0].data;
                }

                altezza = argomento.children[5].children[1].children[0].data;
                weatherForecast[dataStringa][parseInt(valor["data-value"])]["marea"] = {
                  tipo: marea,
                  ora: oraMarea,
                  altezza: altezza
                };
              }
            }
          }
        }
      }
    });

    return weatherForecast;

  } catch (err) {
    console.error("Errore richiesta:", err);
    return {};
  }
}

export default meteo;

